import { render, staticRenderFns } from "./SearchSidebarContentPreview.vue?vue&type=template&id=6d9a6c80&"
import script from "./SearchSidebarContentPreview.vue?vue&type=script&lang=js&"
export * from "./SearchSidebarContentPreview.vue?vue&type=script&lang=js&"
import style0 from "./SearchSidebarContentPreview.vue?vue&type=style&index=0&id=6d9a6c80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports